import React, { useState } from 'react';
import { TYPES, COINS } from '../data/types';
import Coin from '../components/Coin';
import './Landing.css';

const DECK = ['INTJ','INFJ','ENTJ','ENFP','ISTP','ESFP'];

export default function Landing({ onStart }) {
  const [flipped, setFlipped] = useState({});
  const types = Object.values(TYPES);

  const toggleFlip = (code) => setFlipped(f => ({ ...f, [code]: !f[code] }));

  return (
    <div className="land">

      {/* NAV — black */}
      <nav className="l-nav">
        <div className="l-nav-inner">
          <div className="l-logo">
            <span className="l-logo-suit">♦</span>
            <span className="l-logo-text">prismself</span>
            <span className="l-logo-domain">.com</span>
          </div>
          <button className="l-nav-btn" onClick={onStart}>Deal My Card</button>
        </div>
      </nav>

      {/* HERO */}
      <section className="l-hero">
        <div className="l-hero-left">
          <div className="l-badge fade-up">✦ Free · Instant · No account needed</div>
          <h1 className="l-title fade-up">
            Reveal the hidden<br/>
            side of your<br/>
            <em>personality</em>
          </h1>
          <p className="l-sub fade-up">
            Most people only scratch the surface. 30 precise questions
            to surface the traits quietly shaping every decision you make.
          </p>
          <div className="fade-up">
            <button className="l-btn-primary" onClick={onStart}>
              Draw My Card →
            </button>
            <p className="l-note">5 minutes · Free · Instant result</p>
          </div>
        </div>

        {/* Stacked deck */}
        <div className="l-deck fade-up">
          {DECK.map((code, i) => {
            const rotations = [-8, -3, 1, 5, 10, 15];
            const offsets   = [0, -6, -12, -18, -24, -30];
            return (
              <div key={code} className="l-deck-card" style={{
                transform: `rotate(${rotations[i]}deg) translateY(${offsets[i]}px)`,
                zIndex: DECK.length - i,
                animationDelay: `${i * 0.08}s`,
              }}>
                <Coin type={code} coin={COINS[code]} size={130} />
              </div>
            );
          })}
        </div>
      </section>

      {/* SUITS LEGEND */}
      <div className="l-suits">
        <div className="l-suits-inner">
          {[
            { suit:'♠', label:'Analysts', types:'INTJ · INTP · ENTJ · ENTP', color:'#0D0D0D' },
            { suit:'♥', label:'Diplomats', types:'INFJ · INFP · ENFJ · ENFP', color:'#E85D04' },
            { suit:'♣', label:'Sentinels', types:'ISTJ · ISFJ · ESTJ · ESFJ', color:'#0D0D0D' },
            { suit:'♦', label:'Explorers', types:'ISTP · ISFP · ESTP · ESFP', color:'#E85D04' },
          ].map(s => (
            <div key={s.suit} className="l-suit-item">
              <span className="l-suit-sym" style={{ color: s.color }}>{s.suit}</span>
              <div>
                <div className="l-suit-label">{s.label}</div>
                <div className="l-suit-types">{s.types}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* HOW IT WORKS */}
      <section className="l-section">
        <div className="l-container">
          <div className="l-sec-head">
            <span className="l-tag">How it works</span>
            <h2 className="l-sec-title">Three steps to your card</h2>
          </div>
          <div className="l-steps">
            {[
              { n:'01', suit:'♠', title:'Answer 30 questions', desc:'Simple A or B. No right or wrong. Your first instinct is your most honest answer.' },
              { n:'02', suit:'♥', title:'Your card is dealt', desc:'One of 16 unique cards — each with a suit, rank, and personality profile — is yours.' },
              { n:'03', suit:'♦', title:'Receive your full profile', desc:'Enter your email for a deep-dive analysis of your strengths, blind spots, and hidden potential.' },
            ].map(s => (
              <div key={s.n} className="l-step">
                <div className="l-step-top">
                  <span className="l-step-n">{s.n}</span>
                  <span className="l-step-suit">{s.suit}</span>
                </div>
                <h3 className="l-step-title">{s.title}</h3>
                <p className="l-step-desc">{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ALL 16 CARDS */}
      <section className="l-section l-section-black">
        <div className="l-container">
          <div className="l-sec-head">
            <span className="l-tag l-tag-inv">The Full Deck</span>
            <h2 className="l-sec-title l-title-inv">16 Personality Cards</h2>
            <p className="l-sec-sub l-sub-inv">One is dealt specifically for you</p>
          </div>
          <div className="l-cards-grid">
            {types.map(t => (
              <div key={t.code} className="l-card-item" onClick={onStart}>
                <Coin type={t.code} coin={t.coin} size={90} />
                <div className="l-card-label">{t.name}</div>
              </div>
            ))}
          </div>
          <div style={{ textAlign:'center', marginTop:'40px' }}>
            <button className="l-btn-inv" onClick={onStart}>Find My Card →</button>
          </div>
        </div>
      </section>

      {/* QUOTE */}
      <section className="l-section l-section-orange">
        <div className="l-container">
          <blockquote className="l-quote">
            <span className="l-quote-suit">♥</span>
            <p>"Knowing yourself is the beginning of all wisdom."</p>
            <cite>— Aristotle</cite>
          </blockquote>
        </div>
      </section>

      {/* CTA */}
      <section className="l-section">
        <div className="l-container">
          <div className="l-cta">
            <div className="l-cta-cards">
              {['INTJ','ENFP','ISTP'].map((c,i) => (
                <div key={c} className="l-cta-card" style={{ transform:`rotate(${(i-1)*8}deg)`, zIndex:3-i }}>
                  <Coin type={c} coin={COINS[c]} size={100} />
                </div>
              ))}
            </div>
            <h2 className="l-cta-title">What does your card say about you?</h2>
            <p className="l-cta-sub">5 minutes to uncover the patterns shaping your decisions, relationships, and potential.</p>
            <button className="l-btn-primary l-btn-lg" onClick={onStart}>
              Draw My Card — Free →
            </button>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="l-footer">
        <div className="l-container">
          <div className="l-footer-inner">
            <div className="l-footer-logo">♦ prismself<span>.com</span></div>
            <div className="l-footer-links">
              <a href="/privacy">Privacy</a>
              <a href="/terms">Terms</a>
              <a href="/unsubscribe">Unsubscribe</a>
            </div>
            <p className="l-footer-copy">© 2025 prismself.com</p>
          </div>
        </div>
      </footer>
    </div>
  );
}
